// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import type {
  TravelCarParkingSpot,
  ExtendedSuggestionLocation,
} from '../getParkingSpotSuggestions'

/**
 * Transforms a parking spot from Travel car's API into
 * Mozio's place suggestion object
 * @param  {Object} spot The parking spot
 * @return {Object} A Mozio place object
 * @private
 */
const buildParkingSpotSuggestion = (
  spot: TravelCarParkingSpot
): ExtendedSuggestionLocation => {
  const { id, source, name, latitude, longitude, radius, country } = spot

  return {
    spot_id: id,
    spot_source: source,
    display: name,
    value: name,
    terminal: '',
    type: 'place',
    radius,
    country,
    ...parseLatLng(latitude, longitude),
  }
}

export default buildParkingSpotSuggestion
